<div class="create-group-modal-overlay">
  <div class="create-group-modal step-modal">
    <div class="modal-header header-step">
      <div class="d-flex align-items-center">
        @if (createGroupStep === 2) {
        <button class="back-btn mr-2 px-0" (click)="goToPrevStep()">
          <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24">
              <path fill="currentColor"
                d="m7.825 13l4.9 4.9q.3.3.288.7t-.313.7q-.3.275-.7.288t-.7-.288l-6.6-6.6q-.15-.15-.213-.325T4.426 12t.063-.375t.212-.325l6.6-6.6q.275-.275.688-.275t.712.275q.3.3.3.713t-.3.712L7.825 11H19q.425 0 .713.288T20 12t-.288.713T19 13z" />
            </svg>
          </span>
        </button>
        }
        <div class="d-flex align-items-center">
          <h5 style="margin: 0">
            New Group
          </h5>
        </div>
      </div>
      <button class="close-btn" (click)="closeCreateGroupModal()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
          <path fill="none" stroke="#6c6968" stroke-linecap="round" stroke-width="2"
            d="m8 8l4 4m0 0l4 4m-4-4l4-4m-4 4l-4 4" />
        </svg>
      </button>
    </div>

    <div class="modal-body p-0 modal-body-scrollable position-relative">
      <!-- STEP 1: Select Members -->
      @if (createGroupStep === 1) {
      <div class="step-container d-flex flex-column h-100">
        <!-- Top Selected Users Bar -->
        @if (selectedGroupMembers.length > 0) {
        <div class="selected-users-top-bar">
          @for (user of selectedGroupMembers; track user.userId) {
          <div class="selected-user-chip">
            <div class="chip-avatar-wrapper">
              <img [src]="user.profileImage || 'assets/user-icon.png'" (error)="handleImageError($event)" />
              <div class="remove-chip-overlay" (click)="toggleGroupMemberSelection(user)">
                <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                  <path fill="none" stroke="#ffffff" stroke-linecap="round" d="m6 6l12 12m0-12L6 18" stroke-width="1" />
                </svg>
              </div>
            </div>
            <span class="chip-name text-truncate">{{ user.displayName || user.userName }}</span>
          </div>
          }
        </div>
        }

        <!-- Search Box -->
        <div class="p-2 px-3">
          <input type="text" [(ngModel)]="userSearchTerm" placeholder="Search..." class="form-control" style="
                      border-radius: 20px;
                      background: #f0f2f5;
                      border: none;
                    " />
        </div>

        <!-- Available Users List -->
        <div class="user-selection-section flex-grow-1" style="overflow-y: auto; min-height: 0">
          @if (chatLoader) {
          <div class="d-flex justify-content-center align-items-center p-4">
            <span class="loader"><span class="dot"></span></span>
          </div>
          } @else {
          <div class="user-selection-list h-100" style="max-height: none; border: none">
            @for (user of filteredAvailableUsers; track user.userId) {
            <div class="user-selection-item" [class.selected]="selectedGroupMembers.includes(user)"
              (click)="toggleGroupMemberSelection(user)">
              <div class="d-flex align-items-center">
                <img [src]="user.profileImage || 'assets/user-icon.png'" (error)="handleImageError($event)"
                  class="user-avatar-sm" />
                <span class="ml-2">{{ user.displayName || user.userName }}</span>
              </div>
              <div class="selection-checkbox">
                @if (selectedGroupMembers.includes(user)) {
                <span class="checked-icon">✓</span>
                }
              </div>
            </div>
            }
            @if (filteredAvailableUsers.length === 0) {
            <div class="p-3 text-center text-muted">
              No users found.
            </div>
            }
          </div>
          }
        </div>

        <!-- Floating Next Button -->
        <div class="floating-action-container">
          <button class="floating-btn" (click)="goToNextStep()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
              <path fill="currentColor"
                d="M11.1 2.85a.5.5 0 0 1-.108-.546a.5.5 0 0 1 .816-.162l4 4a.5.5 0 0 1 .147.354a.5.5 0 0 1-.147.354l-4 4a.5.5 0 1 1-.708-.708l3.15-3.15H6.46c-.939 0-1.62 0-2.15.037c-.532.036-.888.107-1.18.23a3.5 3.5 0 0 0-1.89 1.89c-.123.296-.193.652-.23 1.18c-.037.537-.037 1.22-.037 2.15a.5.5 0 0 1-1 0v-.019c0-.916 0-1.63.04-2.2c.04-.583.121-1.06.302-1.5a4.5 4.5 0 0 1 2.44-2.44c.44-.182.916-.264 1.5-.303c.575-.04 1.29-.04 2.2-.04h7.815l-3.15-3.15z" />
            </svg>
          </button>
        </div>
      </div>
      }

      <!-- STEP 2: Group Info -->
      @if (createGroupStep === 2) {
      <div class="step-container step-2-layout d-flex flex-column align-items-center p-4">
        <!-- Group Image Upload -->
        <div class="group-image-upload mb-4">
          <div class="image-circle" (click)="fileInput.click()">
            @if (newGroupImage) {
            <img [src]="newGroupImage" (error)="handleGroupImageError($event)" class="preview-full" />
            } @else {
            <div class="camera-placeholder">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 48 48">
                <path fill="#512da8" d="M33.9 12.1H14.2L17.6 7c.4-.6 1-.9 1.7-.9h9.6c.7 0 1.3.3 1.7.9z" />
                <path fill="#8667c4" d="M14 11H8V9.2C8 8.5 8.5 8 9.2 8h3.6c.7 0 1.2.5 1.2 1.2z" />
                <path fill="#5e35b1"
                  d="M40 42H8c-2.2 0-4-1.8-4-4V14c0-2.2 1.8-4 4-4h32c2.2 0 4 1.8 4 4v24c0 2.2-1.8 4-4 4" />
                <circle cx="24" cy="26" r="12" fill="#512da8" />
                <circle cx="24" cy="26" r="9" fill="#b388ff" />
                <path fill="#c7a7ff"
                  d="M29 23c-1.2-1.4-3-2.2-4.8-2.2s-3.6.8-4.8 2.2c-.5.5-.4 1.3.1 1.8s1.3.4 1.8-.1c1.5-1.7 4.3-1.7 5.8 0c.3.3.6.4 1 .4q.45 0 .9-.3c.4-.4.5-1.3 0-1.8" />
                <ellipse cx="11" cy="13.5" fill="#8667c4" rx="2" ry="1.5" />
              </svg>
            </div>
            }
          </div>
          <input #fileInput type="file" (change)="onGroupImageSelected($event)" style="display: none"
            accept="image/*" />
        </div>

        <!-- Group Name Input -->
        <div class="group-name-wrapper w-100 px-4">
          <input type="text" [(ngModel)]="newGroupName" placeholder="Enter group name..."
            class="form-control group-name-input" maxlength="100" />
        </div>
        <div class="group-name-wrapper w-100 px-4 mt-2">
          <textarea [(ngModel)]="newDiscription" placeholder="Enter description"
            class="form-control group-name-input group-desc-textarea" rows="2"
            style="white-space: pre-wrap; resize: none;"></textarea>
        </div>

        <!-- Selected Users List -->
        @if (selectedGroupMembers.length > 0) {
        <div class="vertical-user-list w-100 mt-3 custom-scroll">
          @for (user of selectedGroupMembers; track user.userId) {
          <div class="vertical-user-item">
            <div class="d-flex align-items-center">
              <img [src]="user.profileImage || 'assets/user-icon.png'" (error)="handleImageError($event)"
                class="user-avatar-sm mr-2" style="
                              width: 32px;
                              height: 32px;
                              border-radius: 50%;
                              object-fit: cover;
                            " />
              <span class="text-truncate ml-2" style="font-size: 14px; font-weight: 500">{{ user.displayName ||
                user.userName }}</span>
            </div>
            <div class="remove-icon-btn" (click)="toggleGroupMemberSelection(user)">
              <i class="fa fa-times" style="font-size: 12px; color: #ef5350; cursor: pointer;"></i>
            </div>
          </div>
          }
        </div>
        }

        <!-- Floating Create Button -->
        <div class="floating-action-container">
          <button class="floating-btn success-btn" (click)="createGroupChat()" [disabled]="isCreatingGroup">
            @if (isCreatingGroup) {
            <i class="fa fa-spinner fa-spin"></i>
            } @else {
            <i class="fa fa-check"></i>
            }
          </button>
        </div>
      </div>
      }
    </div>
  </div>
</div>